document.addEventListener('DOMContentLoaded', function() {
  // Select the block with attribute data-filter-type="price" within .cc-active-list
  const activeFiltersContainer = document.querySelector('.active-filters.flex.flex-wrap');
  const priceRangeBlock = activeFiltersContainer.querySelector('[data-filter-type="price"]');

  // Function to update price range display from URL parameters
  function updatePriceRange() {
    // Parse current URL search parameters
    const urlParams = new URLSearchParams(window.location.search);
    const priceMin = urlParams.get('filter.p.m.custom.price_min');
    const priceMax = urlParams.get('filter.p.m.custom.price_max');
    
    // Get the active filters container
    const activeFiltersContainer = document.querySelector('.active-filters.flex.flex-wrap');
    if (!activeFiltersContainer) return;
    
    // Try to select the price filter element
    let priceFilterAnchor = activeFiltersContainer.querySelector('.js-price-filter');
    if (!priceFilterAnchor) {
      console.log("no price filter found; creating new one");
      // Insert the new price filter element into the active filters container
      activeFiltersContainer.insertAdjacentHTML('beforeend', `
        <a href="/collections/red-wine?filter.p.m.custom.price_max=${priceMax || ''}&filter.p.m.custom.price_min=${priceMin || ''}" class="active-filter flex items-center text-current js-price-filter ${priceMin || priceMax ? '' : 'hidden'}" id="price-range" data-key="filter.p.m.custom.first_variant_price" data-filter-type="price" data-params="/collections/red-wine?filter.p.m.custom.price_max=${priceMax || ''}&filter.p.m.custom.price_min=${priceMin || ''}">
          <span>
            <span class="price-range-min">${priceMin || '0.00'}</span> - 
            <span class="price-range-max">${priceMax || ''}</span>
          </span>
          <!-- Optionally, add close icon markup here -->
        </a>
      `);
      priceFilterAnchor = activeFiltersContainer.querySelector('.js-price-filter');
    }
    
    // Update the price range spans inside the price filter element
    const priceRangeMinEl = priceFilterAnchor.querySelector('.price-range-min');
    const priceRangeMaxEl = priceFilterAnchor.querySelector('.price-range-max');

    if (priceRangeMinEl) {
      priceRangeMinEl.textContent = priceMin || '0.00';
    }
    if (priceRangeMaxEl) {
      priceRangeMaxEl.textContent = priceMax || '';
    }
  }

  // Call update function on initial page load
  updatePriceRange();

  // --- Monitor URL changes ---
  // Override history.pushState and history.replaceState to dispatch a custom event on URL change
  (function(history){
    const pushState = history.pushState;
    history.pushState = function(state) {
      const result = pushState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return result;
    };

    const replaceState = history.replaceState;
    history.replaceState = function(state) {
      const result = replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return result;
    };
  })(window.history);

  // Listen for popstate events and dispatch our custom event for URL changes
  window.addEventListener('popstate', function(){
    window.dispatchEvent(new Event('locationchange'));
  });

  // When the custom event fires, update the price range values from the URL
  window.addEventListener('locationchange', updatePriceRange);
});
